import { render, staticRenderFns } from "./BlockLink.vue?vue&type=template&id=0a6da888&scoped=true"
import script from "./BlockLink.vue?vue&type=script&lang=js"
export * from "./BlockLink.vue?vue&type=script&lang=js"
import style0 from "./BlockLink.vue?vue&type=style&index=0&id=0a6da888&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6da888",
  null
  
)

export default component.exports